import {
  Dropdown,
  DropdownItem,
  type DropdownItemProps,
  DropdownMenu,
  type DropdownMenuProps,
  type DropdownProps,
  DropdownSection,
  DropdownTrigger,
} from '@heroui/react';

type DropdownItemData = {
  key: string;
  description?: string;
  shortcut?: string;
  startContent?: React.ReactNode;
  showDivider?: boolean;
  title: string;
  isReadOnly?: boolean;
  color?: DropdownItemProps['color'];
  className?: string;
};

type DropdownSectionData = {
  key: string;
  title?: string;
  items: DropdownItemData[];
};

type Props = Omit<DropdownProps, 'type' | 'placement' | 'items' | 'children'> & {
  children: React.ReactNode;
  items?: DropdownItemProps<DropdownItemData>[];
  sections?: DropdownSectionData[];
  disabledKeys?: DropdownMenuProps['disabledKeys'];
  onAction?: DropdownMenuProps['onAction'];
};

export const ActionDropdown = ({ children, items, sections, onAction, disabledKeys, ...props }: Props) => {
  return (
    <Dropdown type='listbox' placement='bottom-end' {...props}>
      <DropdownTrigger>{children}</DropdownTrigger>
      <DropdownMenu
        disabledKeys={disabledKeys}
        onAction={onAction}
        aria-label='Dropdown menu with description'
        variant='faded'
      >
        {sections
          ? sections.map((section) => (
              <DropdownSection key={section.key} title={section.title}>
                {section.items.map((item) => (
                  <DropdownItem
                    key={item.key}
                    description={item.description}
                    shortcut={item.shortcut}
                    startContent={item.startContent}
                    showDivider={item.showDivider}
                    color={item.color}
                    isReadOnly={item.isReadOnly}
                    className={item.className}
                  >
                    {item.title}
                  </DropdownItem>
                ))}
              </DropdownSection>
            ))
          : (items || []).map((item) => (
              <DropdownItem
                key={item.key}
                description={item.description}
                shortcut={item.shortcut}
                startContent={item.startContent}
                showDivider={item.showDivider}
                isReadOnly={item.isReadOnly}
                color={item.color}
                className={item.className}
              >
                {item.title}
              </DropdownItem>
            ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export type { DropdownItemData, DropdownSectionData };
